import { crmSystem } from "@/constants/crm/_shared/systems";
import { crmRegistry } from "@/features/crm_system/lib/_core/crmRegistry";
import { AllCrmsFieldsTypes } from "@/features/crm_system/lib/_core/crmSystem";
import { QuestionFormSchemaType } from "@/features/question/components/organisms/QuestionForm";
import { Tables } from "@/lib/supabase/supabase_types_override";
import { Question } from "@/lib/supabase/types";
import React, { memo, Suspense } from "react";
import { UseFormReturn } from "react-hook-form";

interface FieldFormProps {
    fieldType: AllCrmsFieldsTypes;
    field: Question;
    crmSystem: crmSystem
    form: UseFormReturn<QuestionFormSchemaType>
    questionBankQuestion: Tables<'question_bank'> | null;
    isFormDisabled: boolean;
    setFormValue: (name: string, value: string | string[]) => void;
    isFieldTypeSetAutomatically?: boolean;
}

interface FieldFormContextProps extends FieldFormProps { }

const fieldContext = React.createContext<FieldFormContextProps | null>(null);

export const useFieldFormContext = () => {
    const context = React.useContext(fieldContext);
    if (!context) {
        throw new Error("useFieldFormContext must be used within FieldFormProvider");
    }
    return context;
};

const FieldFormProvider = (props: FieldFormContextProps & { children: React.ReactNode }) => {
    return <fieldContext.Provider value={props}>{props.children}</fieldContext.Provider>
}

export const FieldForm = memo((props: FieldFormProps) => {
    const Field = crmRegistry.getFieldFormField(props.crmSystem, props.fieldType);
    if(!props.form.getValues()?.id && !props.isFieldTypeSetAutomatically){
        crmRegistry.resetFieldForm(props.crmSystem, props.fieldType, props.form);
    }
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <FieldFormProvider {...props} >
                <Field />
            </FieldFormProvider>
        </Suspense >
    );
}, (prevProps, nextProps) => {
    return (
        (prevProps.fieldType === nextProps.fieldType)
        && (prevProps.form.getValues()?.id === nextProps.form.getValues()?.id)
    );
});
